import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["setTravelPurpose"] = "travelPurpose/setTravelPurpose";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    setTravelPurpose: createAction(ActionTypes.setTravelPurpose, (data) => ({
        payload: data
    }))
};
